import { createContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { updateCSSVariables } from '../utils/cssVariables'

export const OrganContext = createContext()

const getOrganColor = (organ) => organ?.getOrganColor ?? '#3B88D0'

export const OrganProvider = ({ children }) => {
  const [selectedOrgan, setOrgan] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  const selectOrgan = (organ) => {
    setOrgan(organ)
    sessionStorage.setItem('selectedOrgan', JSON.stringify(organ))
    updateCSSVariables(getOrganColor(organ))
    setLoading(false)
  }

  const clearOrganSelection = () => {
    sessionStorage.removeItem('selectedOrgan')
    setOrgan(null)
    updateCSSVariables('#4da8ff')
    navigate('/aplicacoes')
  }

  useEffect(() => {
    const savedOrgan = sessionStorage.getItem('selectedOrgan')

    if (savedOrgan) {
      try {
        const organ = JSON.parse(savedOrgan)
        setOrgan(organ)
        updateCSSVariables(getOrganColor(organ))
      } catch (e) {
        console.error(e)
      }
    } else {
      // Se não tem órgão, garante que a cor seja o azul padrão
      updateCSSVariables('#4da8ff')
    }
    setLoading(false) // Sempre encerra o loading
  }, [])

  return (
    <OrganContext.Provider
      value={{
        selectedOrgan,
        selectOrgan,
        loading,
        clearOrganSelection,
      }}>
      {children}
    </OrganContext.Provider>
  )
}
